import {
  BUY_BUTTON_SET_ARTICLE_NUMBER,
  BUY_BUTTON_SET_LOADING,
  BUY_BUTTON_SET_STOCK_STATUS,
  BUY_BUTTON_SET_STOCK_STATUSES,
} from '../constants';
import StockStatus from '../Types/StockStatus';

export const setBuyButtonArticleNumber = (articleNumber: string) => ({
  type: BUY_BUTTON_SET_ARTICLE_NUMBER,
  payload: {
    articleNumber,
  },
});

export const setBuyButtonLoading = (isLoading: boolean) => ({
  type: BUY_BUTTON_SET_LOADING,
  payload: {
    isLoading,
  },
});

export const setBuyButtonStockStatus = (stockStatus: StockStatus) => ({
  type: BUY_BUTTON_SET_STOCK_STATUS,
  payload: {
    stockStatus,
  },
});

export const setBuyButtonStockStatuses = (stockStatuses: { key: string; value: StockStatus }) => ({
  type: BUY_BUTTON_SET_STOCK_STATUSES,
  payload: {
    stockStatuses,
  },
});
